<form autocomplete="off" [formGroup]="appointmentForm" method="post" (ngSubmit)="doSubmitGetAppointment()">

    <div class="row">
        <div class="col-md-12">

            <!-- Source Information Display -->
            <div class="form-group" *ngIf="querySourceType">
                <div class="source-info-box" [class.source-shop]="querySourceType === 'Shop'"
                    [class.source-qr]="querySourceType === 'QR'"
                    [class.source-card]="querySourceType === 'VisitingCard'">
                    <div class="source-info-content">
                        <i class="fas" [class.fa-store]="querySourceType === 'Shop'"
                            [class.fa-qrcode]="querySourceType === 'QR'"
                            [class.fa-id-card]="querySourceType === 'VisitingCard'"></i>
                        <span>{{ getSourceDisplayText() }}</span>
                    </div>
                </div>
            </div>

            <!-- Source Mobile Input - Only for QR and VisitingCard -->
            <div class="form-group" *ngIf="showSourceMobileInput">
                <label for="sourceMobileInput" class="source-mobile-label">
                    <i class="fas fa-user-friends"></i>
                    Referrer's Mobile Number <span class="red_txt">*</span>
                </label>
                <div class="source-mobile-input-wrapper">
                    <input type="text" id="sourceMobileInput" class="form-control"
                        [placeholder]="getSourceMobilePlaceholder()" [(ngModel)]="querySourceMobile"
                        [ngModelOptions]="{standalone: true}" maxlength="10" (input)="onSourceMobileInput($event)"
                        [class.is-valid]="isValidMobile(querySourceMobile)"
                        [class.is-invalid]="querySourceMobile && !isValidMobile(querySourceMobile)"
                        autocomplete="off" />
                    <span class="source-mobile-hint" *ngIf="!isValidMobile(querySourceMobile) && querySourceMobile">
                        <i class="fas fa-exclamation-circle text-danger"></i> Enter valid 10-digit mobile number
                    </span>
                    <span class="source-mobile-hint" *ngIf="isValidMobile(querySourceMobile)">
                        <i class="fas fa-check-circle text-success"></i> Valid mobile number
                    </span>
                </div>
                <small class="form-text text-muted source-instruction">
                    <i class="fas fa-info-circle"></i> {{ getSourceInstruction() }}
                </small>
            </div>

            <!-- Hidden Source fields -->
            <input type="hidden" name="SourceType" value="{{ querySourceType }}">

            <!-- Logged In Status + Location Status - Merged -->
            <div class="form-group" *ngIf="IsLogin && authProfileData">
                <div class="logged-in-status" [class.location-success]="isLocationCaptured"
                    [class.location-error]="!isLocationCaptured && !isCapturingLocation"
                    [class.location-capturing]="isCapturingLocation">

                    <div class="status-row">
                        <!-- Left side: User info + Location status -->
                        <div class="status-left">
                            <i class="fas fa-check-circle"></i>
                            <span>Logged in as: <strong>{{ authProfileData?.UserName || authProfileData?.Name
                                    }}</strong></span>
                            <span class="mobile-separator">|</span>
                            <span>{{ authProfileData?.Mobile }}</span>

                            <!-- Location status inline -->
                            <span class="location-indicator" *ngIf="isLocationCaptured">
                                <span class="sep">|</span>
                                <i class="fas fa-map-marker-alt text-success"></i>
                                <span class="location-text text-success">Verified</span>
                                <span class="badge badge-info ml-1">{{ locationAccuracy?.toFixed(0) }}m</span>
                            </span>
                            <span class="location-indicator" *ngIf="!isLocationCaptured && !isCapturingLocation">
                                <span class="sep">|</span>
                                <i class="fas fa-exclamation-triangle text-danger"></i>
                                <span class="location-text text-danger">Location Required</span>
                            </span>
                            <span class="location-indicator" *ngIf="isCapturingLocation">
                                <span class="sep">|</span>
                                <i class="fas fa-spinner fa-spin text-warning"></i>
                                <span class="location-text text-warning">Capturing...</span>
                            </span>
                        </div>

                        <!-- Right side: Action button -->
                        <div class="status-right">
                            <button type="button" class="btn btn-sm location-action-btn"
                                [class.btn-success]="isLocationCaptured"
                                [class.btn-danger]="!isLocationCaptured && !isCapturingLocation"
                                [class.btn-warning]="isCapturingLocation" (click)="captureLocationWithPermission()"
                                [disabled]="isCapturingLocation">
                                <i class="fas" [class.fa-spinner]="isCapturingLocation"
                                    [class.fa-sync-alt]="!isCapturingLocation"></i>
                                {{ isLocationCaptured ? 'Refresh' : 'Allow Location' }}
                            </button>
                        </div>
                    </div>

                    <!-- Error message (only when location not captured) -->
                    <div *ngIf="locationError && !isLocationCaptured" class="location-error-msg">
                        <i class="fas fa-exclamation-circle"></i> {{ locationError }}
                    </div>
                    <div *ngIf="!isLocationCaptured && !isCapturingLocation && !locationError"
                        class="location-error-msg">
                        <i class="fas fa-info-circle"></i> Click "Allow Location" to verify your shop location
                    </div>
                </div>

            </div>

            <!-- Show login required message when not logged in -->
            <div class="form-group" *ngIf="!IsLogin">
                <div class="login-required-message">
                    <i class="fas fa-lock"></i>
                    Please login to continue property request
                </div>
            </div>

            <!-- Hidden location fields -->
            <input type="hidden" formControlName="Latitude">
            <input type="hidden" formControlName="Longitude">
            <input type="hidden" formControlName="LocationAccuracy">
            <input type="hidden" formControlName="ShopID">

            <!-- Voice Record Button -->
            <div class="form-group">
                <button type="button" class="btn btn-voice-record btn-block" (click)="openVoiceModal()">
                    <span class="mic-icon">🎙️</span> Record Voice Lead <span class="voice-hint">(Speak in English or
                        Telugu)</span>
                </button>
            </div>

            <!-- ============================================ -->
            <!-- BUYER DETAILS SECTION - Gray Strip Header -->
            <!-- ============================================ -->
            <div class="section-header">
                <span class="section-icon">👤</span>
                Enter Buyer Details & Requirement whom you are Referring
            </div>

            <!-- Rest of your form fields... -->
            <div class="form-group">
                <label for="txtAppointmentName">Name<span class="red_txt">*</span></label>
                <div class="voice-input-wrapper">
                    <input type="text" class="form-control" id="txtAppointmentName" placeholder="Enter name"
                        formControlName="Name"
                        [ngClass]="appointmentForm.controls['Name'].invalid ? 'border-danger' : ''" />
                    <div *ngIf="isMobileApp || isAndroidApk" class="voice-input-buttons">
                        <button type="button" class="voice-icon-btn" (click)="startFieldVoice('Name')">
                            🎤
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="txtAppointMobile">Mobile<span class="red_txt">*</span></label>
                <div class="voice-input-wrapper">
                    <input type="text" class="form-control" id="txtAppointMobile" placeholder="Enter mobile number"
                        formControlName="Mobile"
                        [ngClass]="appointmentForm.controls['Mobile'].invalid ? 'border-danger' : ''" />
                    <div *ngIf="isMobileApp || isAndroidApk" class="voice-input-buttons">
                        <button type="button" class="voice-icon-btn" (click)="startFieldVoice('Mobile')">
                            🎤
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>Request Type<span class="red_txt">*</span></label>
                <div id="requestTypeGroup" class="request-type-group">
                    <label class="radio-label">
                        <input name="radio" type="radio" value="Buy" id="radioBuy"
                            (change)="onRequestTypeChange($event)" />
                        <span>Buy</span>
                    </label>
                    <label class="radio-label">
                        <input name="radio" type="radio" value="Sale" id="radioSale"
                            (change)="onRequestTypeChange($event)" />
                        <span>Sale</span>
                    </label>
                    <label class="radio-label">
                        <input name="radio" type="radio" value="Rent" id="radioRent"
                            (change)="onRequestTypeChange($event)" />
                        <span>Rent</span>
                    </label>
                    <label class="radio-label">
                        <input name="radio" type="radio" value="Projects" id="radioProjects"
                            (change)="onRequestTypeChange($event)" />
                        <span>Projects</span>
                    </label>
                    <label class="radio-label">
                        <input name="radio" type="radio" value="Service" id="radioService"
                            (change)="onRequestTypeChange($event)" />
                        <span>Service</span>
                    </label>
                </div>
            </div>

            <div class="form-group" *ngIf="!isServiceTabView">
                <select name="menu1" id="propertyTypeSelect" class="form-control" (change)="onPropertyChange($event)">
                    <option value="" selected="">Property Type</option>
                    <option value="1">Residential</option>
                    <option value="1--1">-- Apartment</option>
                    <option value="1--2">-- Independent</option>
                    <option value="1--3">-- Farm House</option>
                    <option value="1--4">-- Villa</option>
                    <option value="1--5">-- Penthouse</option>
                    <option value="1--6">-- Studio House</option>
                    <option value="1--17">-- Car Parking (R)</option>
                    <option value="1--20">-- Rooftop Leasing for Solar</option>
                    <option value="1--21">-- Event Spaces (Short Time)</option>
                    <option value="1--23">-- PG Service/Co-Living</option>
                    <option value="2">Commercial</option>
                    <option value="2--7">-- Office Space</option>
                    <option value="2--8">-- Showroom</option>
                    <option value="2--9">-- Shop</option>
                    <option value="2--10">-- IT Park (SEZ)</option>
                    <option value="2--11">-- Warehouse</option>
                    <option value="2--18">-- Co-working Spaces</option>
                    <option value="2--22">-- Car Parking (C)</option>
                    <option value="3">Land</option>
                    <option value="3--12">-- Residential</option>
                    <option value="3--13">-- Commercial</option>
                    <option value="3--14">-- Industrial</option>
                    <option value="3--15">-- Agricultural</option>
                    <option value="3--16">-- Farm House</option>
                    <option value="3--19">-- Urban Farming</option>
                </select>
            </div>

            <div class="form-group" *ngIf="isServiceTabView">
                <select name="menu1" class="form-control" (change)="LoadSubCategory($event.target.value)">
                    <option value="">Category Type</option>
                    <option *ngFor="let category of CategoryList"
                        [value]="category.ParentCategory + '-' + category.CatType">{{ category.ParentCategory }}
                    </option>
                </select>
            </div>

            <div class="form-group" *ngIf="isServiceTabView">
                <select name="menu1" class="form-control" formControlName="PropertySubType">
                    <option value="">Sub Category Type</option>
                    <option *ngFor="let category of SubCategoryList" [value]="category.CategoryID">{{ category.Category
                        }}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <label for="txtAppointmentArea">Area/Region<span class="red_txt">*</span></label>
                <div class="voice-input-wrapper">
                    <input type="text" class="form-control" id="txtAppointmentArea"
                        placeholder="Enter preferred area/region (e.g., Gachibowli, Hyderabad)" formControlName="Area"
                        [ngClass]="appointmentForm.controls['Area'].invalid ? 'border-danger' : ''" />
                    <div *ngIf="isMobileApp || isAndroidApk" class="voice-input-buttons">
                        <button type="button" class="voice-icon-btn" (click)="startFieldVoice('Area')">
                            🎤
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="txtAppointmentBudget">Budget (in ₹)<span class="red_txt">*</span></label>
                <div class="voice-input-wrapper">
                    <input type="text" class="form-control" id="txtAppointmentBudget"
                        placeholder="Enter budget (e.g., 50 Lakhs, 1 Crore, 25000 per month)" formControlName="Budget"
                        [ngClass]="appointmentForm.controls['Budget'].invalid ? 'border-danger' : ''" />
                    <div *ngIf="isMobileApp || isAndroidApk" class="voice-input-buttons">
                        <button type="button" class="voice-icon-btn" (click)="startFieldVoice('Budget')">
                            🎤
                        </button>
                    </div>
                </div>
                <small class="form-text text-muted">Example: 50 Lakhs, 1.5 Crore, 25000 per month</small>
            </div>

            <div class="form-group"></div>
            <button type="submit" [disabled]="appointmentForm.invalid"
                class="btn btn-primary pad25L pad25R">Submit</button>
        </div>
        <div *ngIf="isDesktopBrowser" class="desktop-voice-message">
            <small>Voice input is available on mobile devices only</small>
        </div>
    </div>
</form>

<!-- Voice Recording Modal -->
<div class="voice-modal" [style.display]="isVoiceModalOpen ? 'flex' : 'none'" (click)="onModalBackdropClick($event)">
    <div class="voice-modal-content">
        <div class="voice-modal-head-row">
            <div class="voice-modal-header">🎙️ Voice Assistant</div>
            <button type="button" class="voice-modal-close-btn" (click)="closeVoiceModal()">✕</button>
        </div>
        <button type="button" class="voice-record-toggle-btn" [class.recording]="isMobileRecording"
            (click)="toggleVoiceRecording()">
            {{ isMobileRecording ? '⏹️ Stop Recording' : '🎤 Start Recording' }}
        </button>

        <div class="voice-waveform-horizontal" *ngIf="isMobileRecording">
            <div class="waveform-bars">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
            <span class="recording-text">Recording... Speak clearly</span>
        </div>

        <div class="voice-processing-indicator" *ngIf="isProcessingVoice">
            <div class="spinner"></div>
            <span>Processing with AI transcription...</span>
        </div>

        <label class="voice-modal-label">Transcript (Edit if needed)</label>
        <textarea rows="4" class="voice-modal-textarea" [(ngModel)]="voiceTranscript"
            placeholder="Transcribed text will appear here after you stop recording. You can edit before applying."></textarea>

        <div class="voice-modal-actions">
            <button type="button" class="btn btn-primary apply-btn" (click)="applyVoiceToForm()"
                [disabled]="!voiceTranscript.trim()">Apply to Form</button>
            <button type="button" class="btn btn-secondary cancel-btn" (click)="closeVoiceModal()">Cancel</button>
        </div>
    </div>
</div>

<!-- Login Modal Component -->
<app-login-modal></app-login-modal>